<template lang="pug">
	.section.section--white
		.donation-success
			VueFeedback(type="success")
				template(slot="feedback-title") Köszönjük adományát!
				template(slot="feedback-content")
					p.sf-text Ön is hozzájárult ahhoz, hogy egy jó cél megvalósuljon. Látogasson vissza oldalunkra máskor is, és kövesse figyelemmel #[a(href="/adomanyozas/Korabbi-projektek") eredményeinket], valamint #[a(href="/adomanyozas/Aktualis-projektek") további kampányainkat].
					p.sf-text SimplePay tranzakció azonosító:
						strong  {{transactionId}}
</template>
<script>
import VueFeedback from '@ui-common/vue-feedback';
export default {
	props: {
		transactionId: {
			required: true
		}
	},
	components: {
		VueFeedback
	},
	mounted() {
		this.$scrollTo(this.$el);
	}
};
</script>
